export default __webpack_public_path__ + "static/experiences-title-410a41d1f7486f2d97fd271ec4a95b6d.png";